var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Card } from '@aptive-env/storybook';
import { Close, Layers } from 'icons';
export var MapTypeChangeButton = function (_a) {
    var open = _a.open, onClick = _a.onClick;
    return (_jsx(Card, __assign({ className: "h-[40px] w-[40px] bg-white rounded-full cursor-pointer flex items-center justify-center shadow-[0_1px_2px_0_#0000004D]", onClick: onClick }, { children: open ? _jsx(Close, {}) : _jsx(Layers, {}) })));
};
